import { useContext, useState } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

function useIntegration() {
  const { api } = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);

  // ================= GET POS TERMINAL =================
  const getPosTerminal = async (payload) => {
    try {
      setLoading(true);

      const res = await api.post(
        "/Order/getPosTerminal",
        payload
      );

      return res.data;
    } catch (error) {
      console.error("getPosTerminal error:", error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  // ================= INSERT POS TERMINAL =================
  const insertPosTerminal = async (payload) => {
    try {
      setLoading(true);

      const res = await api.post(
        "/Order/insertPosTerminal",
        payload
      );

      return res.data;
    } catch (error) {
      console.error("insertPosTerminal error:", error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  // ================= GET POS DRAWER =================
  const getPosDrawer = async (payload) => {
    try {
      setLoading(true);

      const res = await api.post(
        "/Order/getPosDrawer",
        payload
      );

      return res.data;
    } catch (error) {
      console.error("getPosDrawer error:", error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  // ================= INSERT POS DRAWER =================
  const insertPosDrawer = async (payload) => {
    try {
      setLoading(true);

      const res = await api.post(
        "/Order/insertPosDrawer",
        payload,
        {
          headers: {
            "Content-Type": "application/json-patch+json",
          },
        }
      );

      return res.data;
    } catch (error) {
      console.error("insertPosDrawer error:", error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    setLoading,
    getPosTerminal,
    insertPosTerminal,
    getPosDrawer,
    insertPosDrawer,
  };
}

export default useIntegration;